/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import styles from "./InniBlock.module.css";
import "swiper/css";

import { openInNewTab } from "@/components/shared/utils";

export default function InniBlock() {
  const [mySwiperRef, setMySwiperRef] = useState<any>(null);

  const [index, setIndex] = useState<number>(0);
  const fillArray = [0, 1, 2, 3, 4, 5];

  useEffect(() => {
    if (mySwiperRef) mySwiperRef?.slideTo(index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  const mapped = [
    <SlideOne key={0} />,
    <SlideTwo key={1} />,
    <SlideThree key={2} />,
    <SlideFour key={3} />,
    <SlideFive key={4} />,
    <SlideSix key={5} />,
  ].map((c, i) => {
    return <SwiperSlide key={i}>{c}</SwiperSlide>;
  });

  const mappedDots = fillArray.map((dot)=>{
    return(
        <div className={styles.dot} style={{opacity: index === dot ? 1 : 0.35}} key={dot}></div>
    )
  })

  return (
    <div className={styles.main}>
      <div className={styles.wrapper}>
        <Swiper
          min-height={391}
          autoHeight={false}
          slidesPerView={1}
          touchReleaseOnEdges={true}
          onSlideChange={(e) => {
            setIndex(e.activeIndex);
          }}
          scrollbar={{ draggable: true }}
          threshold={1}
          onSwiper={setMySwiperRef}
        >
          {mapped}
        </Swiper>
      </div>
      <div className={styles.dotWrapper}>{mappedDots}</div>
    </div>
  );
}

function SlideOne() {
  const handleClick = () => {
    if (window.Android) {
      window.Android.openInNewTab("https://www.inni.date/");
    } else {
      openInNewTab("https://www.inni.date/");
    }
  };

  return (
    <div className={styles.slideContianerOne}>
      <p className={styles.pst}>Pssstt...</p>
      <h2 style={{ marginTop: "87px" }} className={styles.title}>
        {"We're building a dating app"}
      </h2>
      <button
        onClick={handleClick}
        style={{ marginTop: "56px" }}
        className={styles.btn}
      >
        Join the waitlist at www.inni.date
      </button>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="16"
        viewBox="0 0 32 16"
        fill="none"
        style={{ marginTop: "auto" }}
      >
        <path
          d="M30.747 8.74702C31.1596 8.33445 31.1596 7.66555 30.747 7.25298L24.0239 0.529824C23.6113 0.117257 22.9424 0.117257 22.5298 0.529824C22.1173 0.94239 22.1173 1.61129 22.5298 2.02386L28.506 8L22.5298 13.9761C22.1173 14.3887 22.1173 15.0576 22.5298 15.4702C22.9424 15.8827 23.6113 15.8827 24.0239 15.4702L30.747 8.74702ZM0 8L-9.23572e-08 9.05644L30 9.05645L30 8L30 6.94356L9.23572e-08 6.94356L0 8Z"
          fill="#FFFFF2"
        />
      </svg>
    </div>
  );
}

function SlideTwo() {
  return (
    <div className={styles.slideContianerTwo}>
      <h2 className={styles.title}>Introducing Inni</h2>
      <img className={styles.image} src="/inni/slideTwoImage.png" alt="" />
    </div>
  );
}

function SlideThree() {
  return (
    <div style={{paddingTop: "14px"}} className={styles.slideContianerTwo}>
      <h2 className={styles.title}>Know your compatibility</h2>
      <img className={styles.image} src="/inni/slideThreeImage.png" alt="" />
    </div>
  );
}


function SlideFour() {
  return (
    <div style={{paddingTop: "14px"}} className={styles.slideContianerTwo}>
      <h2 className={styles.title}>{"Explore what's important to you"}</h2>
      <img className={styles.image} src="/inni/slideFourImage.png" alt="" />
    </div>
  );
}

function SlideFive() {
  return (
    <div style={{paddingTop: "14px"}} className={styles.slideContianerTwo}>
      <h2 className={styles.title}>{"Go deep with our relationship AI"}</h2>
      <img className={styles.image} src="/inni/slideFiveImage.png" alt="" />
    </div>
  );
}

function SlideSix() {
  const handleClick = () => {
    if (window.Android) {
      window.Android.openInNewTab("https://www.inni.date/");
    } else {
      openInNewTab("https://www.inni.date/");
    }
  };

  return (
    <div className={styles.slideContianerOne}>
      <h2 style={{ marginTop: "103px", maxWidth: "299px" }} className={styles.title}>
        {"Launching fall 2025"}
      </h2>
      <button
        onClick={handleClick}
        style={{ marginTop: "56px" }}
        className={styles.btn}
      >
        Join the waitlist at www.inni.date
      </button>
    </div>
  );
}